import { Card, CardBody, Col, Row } from "reactstrap";
import { H5, H6, P } from "../../../AbstractElements";
import { LatestArticlesVideosTitle } from "../../../Constants/Constants";
import { LatestArticlesVideosProps } from "../../../Types/MiscellaneousType";

const LatestArticlesVideos: React.FC<LatestArticlesVideosProps> = ({ titleClass, rowClass, divClass, data }) => {
  return (
    <Col lg="12">
      <div className="header-faq">
        <H5 className={`mb-0 ${titleClass}`}>{LatestArticlesVideosTitle}</H5>
      </div>
      <Row className={rowClass}>
        {data.map((data) => (
          <Col xl="4" className={data.id !== 3 ? "col-md-6" : ""} key={data.id}>
            <Row>
              {data.child.map((item) => (
                <Col key={item.id} className={item.colClass}>
                  <Card>
                    <CardBody>
                      <div className={`d-flex ${divClass}`}>
                        {item.icon}
                        <div className="flex-grow-1">
                          <H6 className="pb-2 f-w-600">{item.title}</H6>
                          <P>{item.text}</P>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
          </Col>
        ))}
      </Row>
    </Col>
  );
};
export default LatestArticlesVideos;
